import { ListItemIcon, ListItemIconProps, ListItemText, ListItemTextProps, Drawer, DrawerProps, IconButtonProps, IconButton, Toolbar } from "@mui/material"
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { lighten } from "polished";
import React from "react"
import LogoBranca from '../../../Images/LogoPequena.png';
import { isMobileDevice, getCSSVariableValue } from "../../../commons/utils";
import { Menu } from "lucide-react";

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

export const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
    open?: boolean;
}>(({ theme, open }) => ({
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: 'var(--side-bar-color)',
    marginLeft: !isMobileDevice() ? `-${DRAWER_WIDTH}px` : '0',
    ...(open && {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0
    }),
}));

export const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${DRAWER_WIDTH}px)`,
        marginLeft: `${DRAWER_WIDTH}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

interface VbListItemIconProps extends ListItemIconProps {
    icon?: any;
}

export const VbListItemIcon = (props: VbListItemIconProps) => {
    return (
        <ListItemIcon
            sx={{
                color: 'inherit',
                marginRight: '-1.5rem',
                padding: '6px 0'
            }}
            {...props}
        >
            {React.cloneElement(props.icon, { size: 20, style: { marginBottom: 3 } })}
        </ListItemIcon>
    )
}

interface VbListItemTextProps extends ListItemTextProps {
    label?: string;
    fontWeight?: string;
}

export const VbListItemText = (props: VbListItemTextProps) => {
    return (
        <ListItemText
            primaryTypographyProps={{
                color: '#fff',
                fontWeight: props.fontWeight ? props.fontWeight : 'medium',
                fontSize: '14px'
            }}
            sx={{ my: 0.35, whiteSpace: 'pre-line' }}
            primary={props.label}
            {...props}
        />
    )
}

export const DRAWER_WIDTH = 275;

export const VbDrawer: React.FC<DrawerProps> = (props) => {
    return (
        <Drawer
            anchor={'left'}
            sx={{
                width: DRAWER_WIDTH,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: DRAWER_WIDTH,
                    background: 'var(--side-bar-color)',
                    boxSizing: 'border-box',
                    borderRight: '0px',
                    '&::-webkit-scrollbar': {
                        width: '6px'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: lighten(.1, getCSSVariableValue('var(--side-bar-color)')),
                        borderRadius: '2px'
                    },
                },
            }}
            PaperProps={{
                style: { backgroundColor: 'var(--side-bar-color)', color: '#fff' }
            }}
            {...props}
        />
    )
}

export const VbIconButtonAuxSideBar: React.FC<IconButtonProps> = (props) => {
    return (
        <IconButton
            color="inherit"
            edge="start"
            sx={{ position: `${isMobileDevice() ? 'fixed' : 'relative'}`, left: `${isMobileDevice() ? '1rem' : '0'}` }}
            {...props}
        >
            <Menu />
        </IconButton>
    )
}

export const VbToolBarLogo = (props: any) => {
    return (
        <Toolbar variant='dense' >
            <div style={{ width: 120, paddingTop: '10px' }}>
                <img
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: `${window.innerWidth > 800 ? '-0.5rem' : ''}` }}
                    src={LogoBranca}
                    alt=''
                    width='120px'
                />
            </div>
            {props.children}
        </Toolbar>
    )
}